__turbopack_context__.v({
  "panel": "_3UYZnW_panel",
  "root": "_3UYZnW_root",
});
